import React from 'react'

const CleanLargeLogoIcon = (
  <>
    <g opacity="0.15">
      <path
        d="M314.337 321.334C314.337 345.173 315.264 368.545 316.654 391.449C350.13 411.785 379.398 438.449 402.851 469.978C553.001 665.364 613.246 1029.03 613.246 1029.03C613.246 1029.03 827.348 627.034 827.348 321.334C827.348 -86.2656 314.337 -101.223 314.337 321.334Z"
        fill="white"
      />
      <path
        d="M316.654 391.449C122.942 276.461 -104.136 492.414 75.2097 726.13C293.019 1009.86 613.246 1029.03 613.246 1029.03C613.246 1029.03 345.85 793.44 316.654 391.449Z"
        fill="white"
      />
      <path
        d="M1008.55 785.026C981.789 813.505 949.508 836.127 913.712 851.486C877.916 866.846 839.37 874.613 800.47 874.305C798.045 835.095 803.666 795.802 816.982 758.883C830.298 721.964 851.022 688.213 877.859 659.741C904.696 631.268 937.068 608.686 972.951 593.407C1008.83 578.128 1047.46 570.481 1086.4 570.943C1088.64 610.102 1082.89 649.308 1069.5 686.133C1056.11 722.958 1035.36 756.617 1008.55 785.026V785.026Z"
        fill="white"
      />
    </g>
  </>
)

export default CleanLargeLogoIcon
